import { EmptyStateIllustration } from "shared/components/illustrations/EmptyStateIllustration";
import { Text } from "shared/components/Spor";
import { SectionStateContentSize } from "shared/components/states/SectionStateContent";
import { StateContentContainer } from "shared/components/states/StateContentContainer";
import { GhostIcon } from "shared/icons/GhostIcon";

type EmptyProps = {
  backgroundColor?: string;
  size?: SectionStateContentSize;
  reason: string;
};

const Content = ({
  size,
  reason,
}: {
  size: SectionStateContentSize;
  reason: string;
}) => {
  if (size === "sm") {
    return (
      <>
        <GhostIcon size={24} />
        <Text textAlign="center" fontSize="sm">
          {reason}
        </Text>
      </>
    );
  }

  if (size === "lg") {
    return (
      <>
        <EmptyStateIllustration height={200} width={200} />
        <Text my={0} textAlign="center" fontSize="md">
          {reason}
        </Text>
      </>
    );
  }

  return (
    <>
      <GhostIcon size={24} />
      <Text textAlign="center" fontSize="sm">
        {reason}
      </Text>
    </>
  );
};

export const EmptyContent = ({
  backgroundColor,
  size = "md",
  reason,
}: EmptyProps) => (
  <StateContentContainer size={size} backgroundColor={backgroundColor}>
    <Content size={size} reason={reason} />
  </StateContentContainer>
);
